import React, { useEffect } from 'react'
import CustomTable from '../../../Components/Table/CustomTable'
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
import { Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import BannerinputGetModal from '../../ContentManagement/CommonModal/BannerModal/BannerinputGetModal';
import SchemeCreateModal from '../Modal/SchemeCreateModal';
import QuestionAnswersModal from '../Modal/QuestionAnswersModal';
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModal';

const QuestionAnswers = () => {
    const dispatch = useDispatch()
    const tableData = [
        { Question: 'Lorem Ipsum is simply dummy text of the printing?',Answers:"Lorem Ipsum is simply dummy text of the printing..." , Status: "Pending" },
        { Question: 'Lorem Ipsum is simply dummy text of the printing?',Answers:"Lorem Ipsum is simply dummy text of the printing..." , Status: "Pending" },
        

    ];
    const tableHeadData = ['S.No', 'Question', "Answers", 'Status'];

    useEffect(() => {
        // setHeaderTitleName("User Registration")
        dispatch(setSubHeaderName("Gold Stake Schemes"));
    }, [])
    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>

                <CustomTable tableEdit="tableEdit"
                    tableDelete="tableDelete"

                    tableData={tableData} title="Q&A's" tableHeadData={tableHeadData}
                    modalName={QuestionAnswersModal}
                />
            </Grid>
        </Grid>
    )
}

export default QuestionAnswers